/**
 * CustomGestureSettings.tsx
 * 自作ジェスチャーカードの設定ダイアログの中身
 * 作成済みのカスタムモーション選択と「ジェスチャー作成」画面の呼び出し
 */
import { useReactFlow } from '@xyflow/react';
import type { NodeSettingsProps } from '../../types';
import { useCustomMotions } from '../../config/customMotions';
import { openGestureCreator } from '../../config/gestureCreator';
import { useFlowDisplayLanguage } from '../../displayLanguage';

export function CustomGestureSettings({ node }: NodeSettingsProps<'customGesture'>) {
  const { updateNodeData } = useReactFlow();
  const displayLanguage = useFlowDisplayLanguage();
  const customMotions = useCustomMotions();

  return (
    <div className="space-y-3">
      <label className="block" data-product-tour="card-input-1">
        <span className="mb-1 block text-sm font-medium text-slate-700">
          {displayLanguage === 'en' ? 'custom motion' : 'つくったうごき'}
        </span>
        <select
          value={node.data.motionId ?? ''}
          onChange={(event) => updateNodeData(node.id, { motionId: event.target.value })}
          className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-blue-400"
        >
          <option value="">{displayLanguage === 'en' ? '(none)' : '（えらばない）'}</option>
          {customMotions.map((option) => (
            <option key={option.id} value={option.id}>{option.label}</option>
          ))}
        </select>
      </label>

      <button
        type="button"
        onClick={() => openGestureCreator()}
        className="w-full rounded-lg border border-blue-500 bg-blue-50 px-3 py-2 text-base font-semibold text-blue-700 transition-colors hover:bg-blue-100"
      >
        {displayLanguage === 'en' ? 'Create Gesture' : 'ジェスチャー作成'}
      </button>
      {node.data.motionId && (
        <button
          type="button"
          onClick={() => openGestureCreator(node.data.motionId)}
          className="w-full rounded-lg border border-sky-500 bg-sky-50 px-3 py-2 text-base font-semibold text-sky-700 transition-colors hover:bg-sky-100"
        >
          {displayLanguage === 'en' ? 'Edit Gesture' : 'ジェスチャー編集'}
        </button>
      )}
    </div>
  );
}
